export const config = {
  isProduction: process.env.IS_PRODUCTION ?? "",
  recaptchaSiteKey: "6LfkPcUpAAAAAHY0LHQPFNyM2lvc0SOzRamFE3pD",
  googleMapsApiKey: "AIzaSyCMAjzMx9dsr1-JIo98-JzEwajfS4BB-Eg"
};
